import { useContext, useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Grid,
  IconButton,
  Tooltip,
} from "@material-ui/core";

import Card from "../../../components/cards/Card";

import {
  BarChart,
  ExpandMore,
  OpenInNew,
  PieChart,
  Refresh,
} from "@material-ui/icons";

import Chip from "../../../components/basics/Chip";
import {
  ChartGridSubtitle,
  ChartOptionsTittle,
  GridBreak,
  GridCharts,
  HeaderAccordion,
  RotatingIconButton,
  StyledToggleButton,
  StyledToggleButtonGroup,
  ToggleButtonGroupContainer,
  TypographyStyled,
} from "../styles/DashBoard";

import { memo } from "react";
import { useHistory } from "react-router-dom";
import Loading from "../../../components/basics/Loading";
import SelectErp from "../../../components/basics/SelectErp";
import { DashBoardContext } from "../contexts/DashBoardContext";
import { useDashBoardFinanceiroService } from "../contexts/DashBoardFinanceiroContext";
import useDashBoardController from "../controllers/DashBoardController";
import useDashBoardFinanceiroController from "../controllers/DashBoardFinanceiroController";
import AccountsChartTitleButton from "./AccountsChartTitleButton";
import BillsToPayChart from "./BillsToPayChart";
import BillsToReceiveChart from "./BillsToReceiveChart";
import CashFlowChart from "./CashFlowChart";

const AccordionDashBoardFinanceiro = ({ hiddenAccordionSumary = false }) => {
  const { expanded, loading, dashBoardFilters } = useContext(DashBoardContext);
  const { handleChangeOpenAcordion } = useDashBoardController();
  const { push } = useHistory();
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  const {
    cashFlowChartInfo,
    billsChartsInfo,
    billToPayRefetch,
    billToReceiveRefetch,
    isBillToPayLoading,
    isBillToReceiveLoading,
    isBillToPayRefetchLoading,
    isBillToReceiveRefetchLoading,
    setBillsChartsInfoCompanies,
    setBillsChartsGroupPeriod,
    setBillsChartsSearchDate,
    setBillsChartsActualPeriod,
  } = useDashBoardFinanceiroService();

  const {
    handleRadioCashFlowOptions,
    handleCheckCashFlowOptions,
    refreshCashFlowChart,

    refreshBillsCharts,
    handleChangeBillsToPayChartView,
    handleChangeBillsToReceiveChartView,
    handleChangeBillsToPayGroupPeriod,
    handleChangeBillsToReceiveGroupPeriod,
  } = useDashBoardFinanceiroController();

  useEffect(() => {
    refreshCashFlowChart(dashBoardFilters);
    setBillsChartsInfoCompanies(dashBoardFilters.multicompany);
    setBillsChartsSearchDate(dashBoardFilters);
  }, [
    dashBoardFilters,
    refreshCashFlowChart,
    setBillsChartsGroupPeriod,
    setBillsChartsInfoCompanies,
    setBillsChartsSearchDate,
  ]);

  useEffect(() => {
    refreshBillsCharts();
  }, [
    billsChartsInfo.actualPeriod,
    billsChartsInfo.actualStartDate,
    billsChartsInfo.actualEndDate,
    refreshBillsCharts,
  ]);

  const checkedDisplayOptions = cashFlowChartInfo.checkDisplayOptions
    .filter((displayOption) => displayOption.check)
    .map((option) => option.id);

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(window.innerWidth);
    };
    window.addEventListener("resize", updateDimension);

    return () => {
      window.removeEventListener("resize", updateDimension);
    };
  }, [screenSize]);
  return (
    <>
      <Grid item style={{ marginTop: "4vh" }} xs={12}>
        <Accordion
          expanded={expanded.financeiro}
          onChange={() => handleChangeOpenAcordion("financeiro")}
        >
          {!hiddenAccordionSumary && (
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <HeaderAccordion>
                <Grid container>
                  <Grid item xs={12}>
                    <Chip
                      bgcolor={"primary"}
                      textcolor="white"
                      label="DADOS FINANCEIRO"
                    />
                  </Grid>
                </Grid>
              </HeaderAccordion>
            </AccordionSummary>
          )}
          <AccordionDetails>
            <Grid container>
              <Loading open={loading.financeiro} />
              <GridCharts item xs={12}>
                <TypographyStyled>Fluxo de Caixa</TypographyStyled>
                <Card
                  chipcolor="transparent"
                  line="left"
                  lineColor="blue"
                  fullWidth
                >
                  <Grid container spacing={3}>
                    <Grid container item alignItems="center" xs>
                      <Grid item>
                        <ToggleButtonGroupContainer>
                          <StyledToggleButtonGroup
                            size="small"
                            value={checkedDisplayOptions}
                            onChange={(event, value) =>
                              handleCheckCashFlowOptions(value)
                            }
                          >
                            {cashFlowChartInfo.checkDisplayOptions.map(
                              (options) => (
                                <StyledToggleButton
                                  key={options.id}
                                  id={options.id}
                                  size="small"
                                  disabled={cashFlowChartInfo.isLoading}
                                  value={options.id}
                                  title="Considerar as datas"
                                >
                                  {options.name}
                                </StyledToggleButton>
                              )
                            )}
                          </StyledToggleButtonGroup>
                        </ToggleButtonGroupContainer>
                      </Grid>
                      <Grid item xs />
                      <Grid item>
                        <ToggleButtonGroupContainer>
                          <StyledToggleButtonGroup
                            size="small"
                            value={cashFlowChartInfo.groupPeriod}
                            exclusive
                            onChange={(_, value) =>
                              handleRadioCashFlowOptions(value)
                            }
                          >
                            {cashFlowChartInfo.radioDateDisplayOptions.map(
                              (option) => (
                                <StyledToggleButton
                                  key={option.id}
                                  value={option.id}
                                  size="small"
                                  disabled={cashFlowChartInfo.isLoading}
                                >
                                  {option.name}
                                </StyledToggleButton>
                              )
                            )}
                          </StyledToggleButtonGroup>
                        </ToggleButtonGroupContainer>
                      </Grid>
                      <Grid item>
                        <RotatingIconButton
                          size="small"
                          isLoading={cashFlowChartInfo.isLoading}
                          onClick={() => refreshCashFlowChart(dashBoardFilters)}
                        >
                          <Refresh />
                        </RotatingIconButton>
                      </Grid>
                      <Grid item>
                        <Tooltip title="Ver detalhes">
                          <IconButton
                            size="small"
                            onClick={() => {
                              push("/financeiro/fluxo");
                            }}
                          >
                            <OpenInNew />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <CashFlowChart />
                    </Grid>
                  </Grid>
                </Card>
              </GridCharts>
              <GridCharts item xs={12}>
                <TypographyStyled>Contas</TypographyStyled>
                <Card
                  chipcolor="transparent"
                  line="left"
                  lineColor="blue"
                  fullWidth
                >
                  <Grid container spacing={3}>
                    <Grid item>
                      <ChartOptionsTittle
                        style={{
                          marginBottom: 8,
                        }}
                      >
                        Período de busca rápida:
                      </ChartOptionsTittle>

                      <SelectErp
                        optionsList={billsChartsInfo.periodsOptions}
                        disableClearable
                        value={billsChartsInfo.actualPeriod}
                        onChange={(option) => {
                          setBillsChartsActualPeriod(option);
                        }}
                        descriptionField="description"
                      />
                    </Grid>
                    <GridBreak />
                    <Grid item xs sm={12} md={6}>
                      <Card
                        chipcolor="transparent"
                        line="left"
                        lineColor="red"
                        fullWidth
                      >
                        <Grid
                          container
                          alignItems="center"
                          style={{ marginBottom: 8 }}
                        >
                          <Grid item xs container direction="column">
                            <Grid item>
                              <AccountsChartTitleButton
                                path={"/financeiro/pagar"}
                                label={"A Pagar"}
                              />
                            </Grid>
                            <Grid item>
                              <ChartGridSubtitle variant="subtitle1">
                                Por data de vencimento
                              </ChartGridSubtitle>
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            item
                            spacing={1}
                            alignItems="center"
                            justifyContent="flex-end"
                            xs={8}
                          >
                            <Grid item>
                              <ToggleButtonGroupContainer>
                                <StyledToggleButtonGroup
                                  size="small"
                                  value={billsChartsInfo.billsToPayGroupPeriod}
                                  exclusive
                                  onChange={handleChangeBillsToPayGroupPeriod}
                                >
                                  {billsChartsInfo.radioDateDisplayOptions.map(
                                    (option) => (
                                      <StyledToggleButton
                                        key={option.id}
                                        value={option.id}
                                        title={screenSize < 1500 && option.name}
                                        disabled={
                                          isBillToPayRefetchLoading ||
                                          isBillToPayLoading ||
                                          billsChartsInfo.billsToPayChartView ===
                                            "pie"
                                        }
                                      >
                                        {screenSize < 1500
                                          ? option.name[0]
                                          : option.name}
                                      </StyledToggleButton>
                                    )
                                  )}
                                </StyledToggleButtonGroup>
                                <Divider flexItem orientation="vertical" />
                                <StyledToggleButtonGroup
                                  size="small"
                                  value={billsChartsInfo.billsToPayChartView}
                                  exclusive
                                  onChange={handleChangeBillsToPayChartView}
                                >
                                  <StyledToggleButton
                                    value="bar"
                                    title="Visualizar gráfico de barras"
                                  >
                                    <BarChart fontSize="small" />
                                  </StyledToggleButton>
                                  <StyledToggleButton
                                    value="pie"
                                    title="Visualizar gráfico de pizza"
                                  >
                                    <PieChart fontSize="small" />
                                  </StyledToggleButton>
                                </StyledToggleButtonGroup>
                              </ToggleButtonGroupContainer>
                            </Grid>
                            <Grid item>
                              <RotatingIconButton
                                isLoading={isBillToPayRefetchLoading}
                                size="small"
                                onClick={billToPayRefetch}
                              >
                                <Refresh />
                              </RotatingIconButton>
                            </Grid>
                          </Grid>
                        </Grid>

                        <GridBreak />
                        <Grid item xs={12}>
                          <BillsToPayChart />
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item xs sm={12} md={6}>
                      <Card
                        chipcolor="transparent"
                        line="left"
                        lineColor="green"
                        fullWidth
                      >
                        <Grid
                          container
                          alignItems="center"
                          style={{ marginBottom: 8 }}
                        >
                          <Grid item xs container direction="column">
                            <Grid item>
                              <AccountsChartTitleButton
                                path={"/financeiro/receber"}
                                label={"A Receber"}
                              />
                            </Grid>
                            <Grid item>
                              <ChartGridSubtitle variant="subtitle1">
                                Por data de vencimento
                              </ChartGridSubtitle>
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            item
                            spacing={1}
                            alignItems="center"
                            justifyContent="flex-end"
                            xs={8}
                          >
                            <Grid item>
                              <ToggleButtonGroupContainer>
                                <StyledToggleButtonGroup
                                  size="small"
                                  value={
                                    billsChartsInfo.billsToReceiveGroupPeriod
                                  }
                                  exclusive
                                  onChange={
                                    handleChangeBillsToReceiveGroupPeriod
                                  }
                                >
                                  {billsChartsInfo.radioDateDisplayOptions.map(
                                    (option) => (
                                      <StyledToggleButton
                                        key={option.id}
                                        value={option.id}
                                        size="small"
                                        title={screenSize < 1500 && option.name}
                                        disabled={
                                          isBillToReceiveRefetchLoading ||
                                          isBillToReceiveLoading ||
                                          billsChartsInfo.billsToReceiveChartView ===
                                            "pie"
                                        }
                                      >
                                        {screenSize < 1500
                                          ? option.name[0]
                                          : option.name}
                                      </StyledToggleButton>
                                    )
                                  )}
                                </StyledToggleButtonGroup>
                                <Divider flexItem orientation="vertical" />
                                <StyledToggleButtonGroup
                                  size="small"
                                  value={
                                    billsChartsInfo.billsToReceiveChartView
                                  }
                                  exclusive
                                  onChange={handleChangeBillsToReceiveChartView}
                                >
                                  <StyledToggleButton
                                    size="small"
                                    value="bar"
                                    title="Visualizar gráfico de barras"
                                  >
                                    <BarChart fontSize="small" />
                                  </StyledToggleButton>
                                  <StyledToggleButton
                                    size="small"
                                    value="pie"
                                    title="Visualizar gráfico de pizza"
                                  >
                                    <PieChart fontSize="small" />
                                  </StyledToggleButton>
                                </StyledToggleButtonGroup>
                              </ToggleButtonGroupContainer>
                            </Grid>
                            <Grid item>
                              <RotatingIconButton
                                isLoading={isBillToReceiveRefetchLoading}
                                size="small"
                                onClick={billToReceiveRefetch}
                              >
                                <Refresh />
                              </RotatingIconButton>
                            </Grid>
                          </Grid>
                        </Grid>

                        <GridBreak />
                        <Grid item xs={12}>
                          <BillsToReceiveChart />
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                </Card>
              </GridCharts>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
};

export default memo(AccordionDashBoardFinanceiro);
